import { defineComponent as _defineComponent } from 'vue'
import { computed, SetupContext, useSlots } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CModal',
  props: {
    value: { type: Boolean },
    size: { default: 'md' },
    title: null,
    titleClass: { default: '' },
    contentClass: null,
    autoFocus: { type: Boolean, default: false }
  },
  emits: ["input", "ok", "closed"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
    (event: 'ok'): void;
    (event: 'closed'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, size: string, title?: string, titleClass: string, contentClass?: string, autoFocus: boolean };



const slots: SetupContext['slots'] = useSlots();



const isOpen = computed({
    get(): boolean {
        return props.value;
    },
    set(value: boolean) {
        emit('input', value);
    }
});

return { __sfc: true,emit, slots, props, isOpen }
}

})